import { useEffect, useState } from "react";
import { fetchRequests } from "./api";

/**
 * How many open requests the signed-in person is on — as technical owner or
 * account lead — for the sidebar. Undefined while unknown and when the person is not linked to a
 * team member — the sidebar then shows no number rather than a wrong one.
 */
export function useMyOpenCount(memberId: string | null | undefined): number | undefined {
  const [count, setCount] = useState<number | undefined>(undefined);

  useEffect(() => {
    if (!memberId) {
      setCount(undefined);
      return;
    }
    let live = true;
    fetchRequests({ member: memberId })
      .then((rows) => {
        if (live) setCount(rows.length);
      })
      .catch(() => {
        // A failed count is not worth an error state in the navigation.
      });
    return () => {
      live = false;
    };
  }, [memberId]);

  return count;
}
